/* src/pages/tender-managers/page-tender-managers.component.scss */
:host {
  display: block;
}
.tender-manager-col--name {
  width: 20rem;
}
.tender-manager-col--actions {
  width: 120px;
}
/*# sourceMappingURL=page-tender-managers.component-7TIKG6GD.css.map */
